module.exports = require("mitt");


//////////////////
// WEBPACK FOOTER
// external "mitt"
// module id = 28
// module chunks = 0 1